angular.module('surfsightApp.controllers').controller('EdgeOTUController', [
  '$scope',
  '$http',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  'dataFromCaller',
  function ($scope, $http, $timeout, $mdDialog, $mdToast, dataFromCaller) {
    $scope.otu_hash = dataFromCaller.otu_hash
    $scope.broadcast = dataFromCaller.broadcast
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.copy_success = function (success_failed) {
      var message = ''
      if (success_failed) {
        message = 'Copied to clip board.'
      } else {
        message = 'Unable to copy.'
      }
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action('ok')
        .actionKey('F1')
        .position('bottom right')
        .hideDelay(5000)
        .parent('#view-otu-container')

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }
    $scope.email_data = {}
    $scope.email_data.email_sms = 'email'
    $scope.email_data.subject = "I'd like to share with you Live Stream"
    $scope.email_data.receiverEmails = []
    $scope.confirmSendEmail = function (ev) {
      if (!$scope.contact_search.text || !$scope.contact_search.text.trim()) {
        var message = 'Please enter email.'
        if ($scope.email_data.email_sms == 'sms') {
          message = 'Please enter phonenumber.'
        }
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action('Ok')
          .actionKey('F1')
          .position('bottom center')
          .hideDelay(3000)
          .parent('#view-otu-container')

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
            }
          })
          .catch(() => {})
        return false
      }
      if (!$scope.email_data.subject || !$scope.email_data.subject.trim()) {
        var message = 'Send email without subject ?'
        if ($scope.email_data.email_sms == 'sms') {
          message = 'Send sms without subject ?'
        }
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action('Yes')
          .actionKey('F1')
          .position('bottom center')
          .hideDelay(3000)
          .parent('#view-otu-container')

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              $scope.sendEmail()
            }
          })
          .catch(() => {})
        return false
      }
      $scope.sendEmail()
    }
    $scope.sendEmail = function () {
      var target_api = 'sendCustomEmail'
      if ($scope.email_data.email_sms == 'sms') {
        target_api = 'sendCustomSMS'
      }
      $scope.email_data.receiverEmails = []
      $scope.email_data.receiverPhonenumbers = []
      $scope.email_data.receiverEmails.push($scope.contact_search.text)
      $scope.email_data.receiverPhonenumbers.push($scope.contact_search.text)
      var request_json = {
        method: 'POST',
        url: USER_BASEURL + '/' + target_api + '/',
        data: $scope.email_data
      }
      $http(request_json).then(
        function (response) {
          var toast = $mdToast
            .simple()
            .textContent(response.data.status.error)
            .action('ok')
            .actionKey('F1')
            .position('bottom')
            .hideDelay(3000)
            .parent('#view-otu-container')

          $mdToast
            .show(toast)
            .then(function (response) {
              if (response == 'ok') {
                // alert('You clicked the \'UNDO\' action.');
              }
            })
            .catch(() => {})
        },
        function (response) {
          handleServerError(response)
          $scope.showMessageToast(response.data.status.error)
        }
      )
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .actionKey('F1')
        .action('ok')
        .position('bottom middle')
        .hideDelay(3000)
        .parent('#view-otu-container')

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }
    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }
  }
])
